var _defs, _g, _circle, _path, _circle2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOfferReward = function SvgOfferReward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 8328",
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 53
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "offer-reward_svg__a",
    x2: 1,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#232d40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171e2d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3206"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3205"
  }, /*#__PURE__*/React.createElement("text", {
    "data-name": "\\u20B9",
    transform: "translate(19.805 21.048)",
    fill: "#ffc165",
    fontSize: 12,
    fontFamily: "Lexend-Regular, Lexend"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -3,
    y: 0
  }, "\u20B9"))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 743",
    fill: "none",
    stroke: "#ffc165",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 26.5,
    r: 26.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 26.5,
    r: 25.5
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3215",
    transform: "translate(4 3.451)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 188",
    cx: 22.622,
    cy: 22.622,
    r: 22.622,
    fill: "url(#offer-reward_svg__a)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9737"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon material-local-offer",
    d: "m32.044 22.202-9.012-9.012a1.99 1.99 0 0 0-1.412-.581h-7.012a2.009 2.009 0 0 0-2 2v7.009a2 2 0 0 0 .591 1.422l9.009 9.015a1.99 1.99 0 0 0 1.412.581 1.958 1.958 0 0 0 1.412-.591l7.009-7.009a1.958 1.958 0 0 0 .591-1.412 2.022 2.022 0 0 0-.591-1.422Zm-15.936-4.586a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5Z",
    fill: "#ffc968",
    stroke: "rgba(0,0,0,0)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9736",
    transform: "rotate(34 -18.029 44.586)"
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 188",
    cx: 3.87,
    cy: 3.87,
    fill: "url(#offer-reward_svg__a)",
    r: 3.87
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7976",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 22128",
    d: "M3.89 5.461a1.582 1.582 0 0 1-.468-.066 1.224 1.224 0 0 1-.389-.2 1.483 1.483 0 0 1-.311-.335l.327-.376a1.483 1.483 0 0 0 .416.429.9.9 0 0 0 .473.119.841.841 0 0 0 .305-.055.53.53 0 0 0 .217-.146.317.317 0 0 0 .08-.212.424.424 0 0 0-.027-.15.376.376 0 0 0-.082-.128.612.612 0 0 0-.141-.106 1.123 1.123 0 0 0-.2-.086 2.026 2.026 0 0 0-.268-.063 2 2 0 0 1-.415-.128.987.987 0 0 1-.3-.2.762.762 0 0 1-.177-.272.967.967 0 0 1-.053-.342.746.746 0 0 1 .082-.345.861.861 0 0 1 .225-.276 1.046 1.046 0 0 1 .338-.182 1.33 1.33 0 0 1 .421-.064 1.467 1.467 0 0 1 .438.062 1.084 1.084 0 0 1 .354.184 1.022 1.022 0 0 1 .256.3l-.336.33a1.08 1.08 0 0 0-.2-.245.765.765 0 0 0-.242-.151.787.787 0 0 0-.284-.051.778.778 0 0 0-.3.053.472.472 0 0 0-.2.148.357.357 0 0 0-.075.224.4.4 0 0 0 .035.17.383.383 0 0 0 .108.137.693.693 0 0 0 .2.106 2.064 2.064 0 0 0 .3.082 2.373 2.373 0 0 1 .433.135 1.321 1.321 0 0 1 .323.192.77.77 0 0 1 .2.248.652.652 0 0 1 .069.3.941.941 0 0 1-.137.513.891.891 0 0 1-.389.334 1.413 1.413 0 0 1-.606.113Z",
    fill: "#ffc165"
  })))))));
};
export default SvgOfferReward;